module.exports = __webpack_public_path__ + "canny-jira-integration-f1aec307f8d525fa160d400b57a0e4cf.png";